import React from 'react';
const SvgSwr = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 132 68", ...props },
    React.createElement("title", null, 'S\xFCdwestrundfunk-Logo'),
    React.createElement("path", { d: "M119.5 17.4a7.5 7.5 0 1 0 7.5 7.4 7.4 7.4 0 0 0-7.5-7.4m0 13.6a6.2 6.2 0 1 1 6.2-6.2 6.2 6.2 0 0 1-6.2 6.2", style: {
            fill: '#fff',
            fillRule: 'evenodd',
        } }),
    React.createElement("path", { d: "M121.9 27.1V21l-6.1 2.2v1.5l2-.7v4.6z", style: {
            fill: '#fff',
            fillRule: 'evenodd',
        } }),
    React.createElement("path", { d: "M82.3 19.4v10.2l5.5 5.4-5.5 5.5v10.1L97.8 35zM48.1 21.1l-2.8 17.4-2.8-17.4h-6.6l-2.8 17.4-2.8-17.4h-6.6l5 28.1H36l3.2-18 3.2 18h7.3l5-28.1zM77.6 49.2h-7.9l-6.7-11h-.3v11h-6.5V21.1c2.4-.2 5.5-.2 8.8-.2 6.7 0 10.5 2.4 10.5 8.3a7.7 7.7 0 0 1-6 7.8l2.1 3.2Zm-8.7-19.4c0-2.2-1.3-3.6-4.4-3.6h-1.8v7.2h1.7c2.7 0 4.5-1.4 4.5-3.8M12.5 49.6a27.2 27.2 0 0 1-5.8-.6l.3-6.2a17.8 17.8 0 0 0 6 1.2c2.3 0 4.1-1 4.1-3 0-4.8-11.1-2.4-11.3-11.7C5.7 24 10 20.5 17 20.5a31.4 31.4 0 0 1 5.1.5v5.7a24.3 24.3 0 0 0-5.3-.8c-2.8 0-4.1 1.1-4.1 2.7C12.7 33 24 31.3 24 40.1c0 5.5-4.4 9.5-11.5 9.5", style: {
            fill: '#fff',
        } }),
    React.createElement("path", { d: "M96.2 19.4v10.2l5.5 5.4-5.5 5.5v10.1L111.7 35z", style: {
            fill: '#fff',
        } })));
export default SvgSwr;
